export default __webpack_public_path__ + "static/media/pool-blue.dcf20da4.svg";